import { Body, Box, Heading } from '@hover/blueprint';
import { iX } from '@hover/icons';
import React, { useState } from 'react';

import { SlideSmartMenu } from 'src/modules/designStudio/components/Toolbar/SlideSmartMenu';
import type { Menu } from 'src/modules/designStudio/constants';
import { Button } from 'src/shared/components';
import { useCurrentPage } from 'src/shared/hooks/useCurrentPage';
import { useTrackingMetadata } from 'src/shared/hooks/useSegmentHistory';
import { featureUpvoted } from 'src/shared/telemetry';

import { CardHeader } from '../CardHeader';

interface PropTypes {
  closeMenu: () => void;
  bodyText?: string;
  headerText: string;
  feature: string;
  menu: Menu | null;
  toolbarRef: React.RefObject<HTMLElement> | null;
}

const InactiveFeatureCard = ({
  closeMenu,
  bodyText,
  headerText,
  feature,
  menu,
  toolbarRef,
}: PropTypes) => {
  const [buttonText, setButtonText] = useState<string>('I want this!');
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const {
    metadata: { job_id: jobId },
  } = useTrackingMetadata();
  const page = useCurrentPage() || '';
  const onPress = () => {
    setIsButtonDisabled(true);
    setButtonText('Thanks for helping us out!');
  };

  return (
    <SlideSmartMenu
      backgroundColor="neutral.backgroundDark"
      closeMenu={closeMenu}
      containerRef={toolbarRef}
      menu={menu}
    >
      <CardHeader rightActionHandler={closeMenu} rightIcon={iX} />
      <Box alignSelf="center">
        <Heading marginBottom={0} size={400} textAlign="center">
          {headerText}
        </Heading>
      </Box>
      <Box alignSelf="center" marginBottom={200}>
        <Body size={400} textAlign="center">
          {bodyText}
        </Body>
      </Box>
      <Box alignSelf="center">
        <Button
          fill="outline"
          isDisabled={!!isButtonDisabled}
          onClick={onPress}
          size="large"
          track={() =>
            featureUpvoted({
              feature,
              page_or_screen_name: page,
              job_id: jobId,
            })
          }
        >
          {buttonText}
        </Button>
      </Box>
    </SlideSmartMenu>
  );
};

export { InactiveFeatureCard };
